import React from 'react';
import { Trash2, FolderInput, X, Download } from 'lucide-react';
import { Button } from '@/shared/ui/button';

interface BulkActionsBarProps {
  selectedFolderCount: number;
  selectedFileCount: number;
  onClear: () => void;
  onDelete: () => void;
  onMove: () => void;
  onDownload: () => void;
  isBusy?: boolean;
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedFolderCount,
  selectedFileCount,
  onClear,
  onDelete,
  onMove,
  onDownload,
  isBusy = false,
}) => {
  const total = selectedFolderCount + selectedFileCount;
  if (total === 0) return null;

  const summary = [
    selectedFolderCount > 0
      ? `${selectedFolderCount} folder${selectedFolderCount === 1 ? '' : 's'}`
      : null,
    selectedFileCount > 0
      ? `${selectedFileCount} file${selectedFileCount === 1 ? '' : 's'}`
      : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border bg-accent/40 px-3 py-2">
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="h-4 w-4" />
      </Button>
      <span className="text-sm font-medium">{summary} selected</span>
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onDownload}
          disabled={isBusy || selectedFileCount === 0}
        >
          <Download className="mr-2 h-4 w-4" />
          Download
        </Button>
        <Button variant="outline" size="sm" onClick={onMove} disabled={isBusy}>
          <FolderInput className="mr-2 h-4 w-4" />
          Move
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="text-destructive hover:text-destructive"
          onClick={onDelete}
          disabled={isBusy}
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Delete
        </Button>
      </div>
    </div>
  );
};
